import { RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

const configureRoutes = (routes: RoutesService) => () => {
  routes.add([
    {
      path: '/states',
      iconClass: 'fas fa-signal',
      name: '::Menu:States',
      order: 302,
      parentName: '::Menu:AgentManagement',
      requiredPolicy: 'LiveChat.States',
    },
  ]);
};

export const STATES_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];
